exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".handCardsWrapper[data-v-cc3e4302]{position:fixed;z-index:100;height:250px;width:100%;bottom:0;background:hsla(0,0%,86.3%,.9);overflow-x:auto}.handCardsBox[data-v-cc3e4302]{display:flex;flex-wrap:no-wrap}.handCard[data-v-cc3e4302]{flex:0 0 80px;min-width:80px}", ""]);

// exports
